import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src'
import { Field } from '~pages/pages-behind-login/onboarded-vessel/questionnaire-page-v2/components/open-section-modal'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface PatchSectionPayload {
  id: string
  fields: Field[]
}

export function usePatchSection(vesselId?: string, flowName?: string) {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: (payload: PatchSectionPayload) =>
      fetchRequest(
        `${apiBase()}/vessels/${vesselId}/section`,
        undefined,
        { ...payload, ...(flowName ? { 'flow-completed': flowName } : {}) },
        'PATCH',
      ),
    onSuccess: (data, variables) => {
      // Invalidate and refetch
      queryClient.invalidateQueries({
        queryKey: [`${apiBase()}/poolpoints/${vesselId}`],
      })
      queryClient.invalidateQueries({
        queryKey: [`/vessels/${vesselId}/data?tab=opsdashboard`],
      })
      queryClient.invalidateQueries({
        queryKey: [`/vessels/${vesselId}/data?tab=restrictions`],
      })
      queryClient.invalidateQueries({
        queryKey: [`/vessels/${vesselId}/questionnaire`],
      })
    },
  })
}
